import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { Button } from '../styles/Button'

//we used dynamic data from props i.e. myData this is diffret in Home and About page but we used same component i.e. HeroSection
const HeroSection = ({ myData }) => {
    const { name, description } = myData
  return (
    <Wrapper>
        <div className='container'>
            <div className="grid grid-two-column">
                <div className='hero-section-data'>
                    <p className='intro-data'>Welcome to</p>
                    <h1>{name}</h1>
                    <div>
                        {description.split('\n\n').map((description, index) => (        //here we are splitting our description data from props
                            <p key={index}>{description}</p>
                         ))}
                    </div>
                    <NavLink to="/products">
                        <Button>Shop Now</Button>
                    </NavLink>
                </div>
                {/* Our homepage hero image*/}
                <div className='hero-section-image'>
                    <figure>
                        <img
                            src="images/main-hero.jpg"
                            alt="hero-section"
                            className="img-style"
                        />
                    </figure>
                </div>
            </div>
        </div>
    </Wrapper>
  )
}
const Wrapper = styled.section`
padding: 12rem 0;

  img {
    min-width: 10rem;
    height: 10rem;
    border-radius: 8%;
    border: 3px solid ${({ theme }) => theme.colors.border};
  }

  .hero-section-data {
    p {
      margin: 2rem 0;
    }

    h1 {
      text-transform: capitalize;
      font-weight: bold;
    }

    .intro-data {
      margin-bottom: 0;
    }
  }

  .hero-section-image {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  figure {
    position: relative;

    &::after {
      content: "";
      width: 60%;
      height: 80%;
      background-color: rgba(81, 56, 238, 0.4);
      position: absolute;
      left: 50%;
      top: -5rem;
      z-index: -1;
    }
  }
  .img-style {
    width: 100%;
    height: auto;
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .grid {
      gap: 10rem;
    }

    figure::after {
      content: "";
      width: 50%;
      height: 100%;
      left: 0;
      top: 10%;
      /* bottom: 10%; */
      background-color: rgba(81, 56, 238, 0.4);
    }
  }
`;

export default HeroSection